import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["className"];
import * as React from 'react';
import clsx from 'clsx';
import { jsx as _jsx } from "react/jsx-runtime";
var CloudMoon = _ref => {
  var {
      className
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    fill: "none",
    viewBox: "0 0 24 24",
    "data-testid": "cloud-moon",
    className: clsx('stroke-current', className)
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M16.5 13c2.5768 0 4.7397-1.772 5.3366-4.164a5.5117 5.5117 0 0 1-1.3366.1636c-3.0376 0-5.5-2.4624-5.5-5.5 0-.4608.0567-.9083.1634-1.336C12.7717 2.7606 11 4.9234 11 7.5c0 .9128.2223 1.7736.6158 2.5312M5 7V3M3 5h4M6 22c-2.2091 0-4-1.7909-4-4 0-1.9779 1.4355-3.6204 3.3215-3.9427C6.1288 11.697 8.3662 10 11 10c2.2882 0 4.2772 1.2809 5.2892 3.1648A4.5025 4.5025 0 0 1 17.5 13c2.4853 0 4.5 2.0147 4.5 4.5S19.9853 22 17.5 22H6Z"
    })
  }));
};
export default CloudMoon;